module.exports = __webpack_public_path__ + "img/rocket-spinner.98de1d8d.svg";